// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ZFQm","col":"styles_col__3DTo7"};